import { ownsOrganization } from 'selectors/Account';
import {
  organizationDetailSelector,
  organizationSelector,
} from 'selectors/Organization';

export const types = {
  ORGANIZATION_REQUEST: 'ORGANIZATIONS/ORGANIZATION_REQUEST',
  ORGANIZATION_SUCCESS: 'ORGANIZATIONS/ORGANIZATION_SUCCESS',
  ORGANIZATION_FAILURE: 'ORGANIZATIONS/ORGANIZATION_FAILURE',
  ORGANIZATION_PRODUCT_REQUEST: 'ORGANIZATIONS/ORGANIZATION_PRODUCT_REQUEST',
  ORGANIZATION_PRODUCT_SUCCESS: 'ORGANIZATIONS/ORGANIZATION_PRODUCT_SUCCESS',
  MARK_PROJECTS_ONBOARDED_REQUEST:
    'ORGANIZATIONS/MARK_PROJECTS_ONBOARDED_REQUEST',
  MARK_PROJECTS_ONBOARDED_SUCCESS:
    'ORGANIZATIONS/MARK_PROJECTS_ONBOARDED_SUCCESS',
  MARK_PROJECTS_ONBOARDED_FAILURE:
    'ORGANIZATIONS/MARK_PROJECTS_ONBOARDED_FAILURE',
  ORGANIZATION_PRODUCT_FAILURE: 'ORGANIZATIONS/ORGANIZATION_PRODUCT_FAILURE',
  UPDATE_BILLING_PLAN_REQUEST: 'ORGANIZATIONS/UPDATE_BILLING_PLAN_REQUEST',
  UPDATE_BILLING_PLAN_SUCCESS: 'ORGANIZATIONS/UPDATE_BILLING_PLAN_SUCCESS',
  UPDATE_BILLING_PLAN_FAILURE: 'ORGANIZATIONS/UPDATE_BILLING_PLAN_FAILURE',

  // subscription initialization
  SUBSCRIPTION_CODE_REVIEW_REQUEST:
    'ORGANIZATIONS/SUBSCRIPTION_CODE_REVIEW_REQUEST',
  SUBSCRIPTION_CODE_REVIEW_SUCCESS:
    'ORGANIZATIONS/SUBSCRIPTION_CODE_REVIEW_SUCCESS',
  SUBSCRIPTION_CODE_REVIEW_FAILURE:
    'ORGANIZATIONS/SUBSCRIPTION_CODE_REVIEW_FAILURE',
  SUBSCRIPTION_STATIC_REQUEST: 'ORGANIZATIONS/SUBSCRIPTION_STATIC_REQUEST',
  SUBSCRIPTION_STATIC_SUCCESS: 'ORGANIZATIONS/SUBSCRIPTION_STATIC_SUCCESS',
  SUBSCRIPTION_STATIC_FAILURE: 'ORGANIZATIONS/SUBSCRIPTION_STATIC_FAILURE',
  // subscription renewal
  SUBSCRIPTION_CODE_REVIEW_RENEW_REQUEST:
    'ORGANIZATIONS/SUBSCRIPTION_CODE_REVIEW_RENEW_REQUEST',
  SUBSCRIPTION_CODE_REVIEW_RENEW_SUCCESS:
    'ORGANIZATIONS/SUBSCRIPTION_CODE_REVIEW_RENEW_SUCCESS',
  SUBSCRIPTION_CODE_REVIEW_RENEW_FAILURE:
    'ORGANIZATIONS/SUBSCRIPTION_CODE_REVIEW_RENEW_FAILURE',
  SUBSCRIPTION_STATIC_RENEW_REQUEST:
    'ORGANIZATIONS/SUBSCRIPTION_STATIC_RENEW_REQUEST',
  SUBSCRIPTION_STATIC_RENEW_SUCCESS:
    'ORGANIZATIONS/SUBSCRIPTION_STATIC_RENEW_SUCCESS',
  SUBSCRIPTION_STATIC_RENEW_FAILURE:
    'ORGANIZATIONS/SUBSCRIPTION_STATIC_RENEW_FAILURE',
  // subscripion cancel
  SUBSCRIPTION_CODE_REVIEW_CANCEL_REQUEST:
    'ORGANIZATIONS/SUBSCRIPTION_CODE_REVIEW_CANCEL_REQUEST',
  SUBSCRIPTION_CODE_REVIEW_CANCEL_SUCCESS:
    'ORGANIZATIONS/SUBSCRIPTION_CODE_REVIEW_CANCEL_SUCCESS',
  SUBSCRIPTION_CODE_REVIEW_CANCEL_FAILURE:
    'ORGANIZATIONS/SUBSCRIPTION_CODE_REVIEW_CANCEL_FAILURE',
  SUBSCRIPTION_STATIC_CANCEL_REQUEST:
    'ORGANIZATIONS/SUBSCRIPTION_STATIC_CANCEL_REQUEST',
  SUBSCRIPTION_STATIC_CANCEL_SUCCESS:
    'ORGANIZATIONS/SUBSCRIPTION_STATIC_CANCEL_SUCCESS',
  SUBSCRIPTION_STATIC_CANCEL_FAILURE:
    'ORGANIZATIONS/SUBSCRIPTION_STATIC_CANCEL_FAILURE',

  TOGGLE_NOTES_LOCK_REQUEST: 'ORGANIZATIONS/TOGGLE_NOTES_LOCK_REQUEST',
  TOGGLE_NOTES_LOCK_SUCCESS: 'ORGANIZATIONS/TOGGLE_NOTES_LOCK_SUCCESS',
  TOGGLE_NOTES_LOCK_FAILURE: 'ORGANIZATIONS/TOGGLE_NOTES_LOCK_FAILURE',
  TOGGLE_FULL_REPO_SEARCH_REQUEST:
    'ORGANIZATIONS/TOGGLE_FULL_REPO_SEARCH_REQUEST',
  TOGGLE_FULL_REPO_SEARCH_SUCCESS:
    'ORGANIZATIONS/TOGGLE_FULL_REPO_SEARCH_SUCCESS',
  TOGGLE_FULL_REPO_SEARCH_FAILURE:
    'ORGANIZATIONS/TOGGLE_FULL_REPO_SEARCH_FAILURE',
  UPDATE_BILLING_INFO_REQUEST: 'ORGANIZATIONS/UPDATE_BILLING_INFO_REQUEST',
  UPDATE_BILLING_INFO_SUCCESS: 'ORGANIZATIONS/UPDATE_BILLING_INFO_SUCCESS',
  UPDATE_BILLING_INFO_FAILURE: 'ORGANIZATIONS/UPDATE_BILLING_INFO_FAILURE',
  INVOICE_REQUEST: 'ORGANIZATIONS/INVOICE_REQUEST',
  INVOICE_SUCCESS: 'ORGANIZATIONS/INVOICE_SUCCESS',
  INVOICE_FAILURE: 'ORGANIZATIONS/INVOICE_FAILURE',
};

export const initialState = {
  error: null,
  isLoading: false,
  isLoadingInvoices: false,
  isUpdating: false,
  byUUID: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.ORGANIZATION_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.ORGANIZATION_SUCCESS:
      const { uuid, organization } = action;
      return {
        ...state,
        isLoading: false,
        byUUID: {
          ...state.byUUID,
          [uuid]: organization,
        },
      };
    case types.ORGANIZATION_FAILURE:
      return { ...state, isLoading: false, error: action.error };
    case types.ORGANIZATION_PRODUCT_REQUEST:
      return { ...state, isUpdating: true, error: null };
    case types.ORGANIZATION_PRODUCT_SUCCESS:
      return { ...state, isUpdating: false };
    case types.ORGANIZATION_PRODUCT_FAILURE:
      return { ...state, isUpdating: false, error: action.error };
    case types.UPDATE_BILLING_PLAN_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.UPDATE_BILLING_PLAN_SUCCESS:
      return { ...state, isLoading: false };
    case types.UPDATE_BILLING_PLAN_FAILURE:
      return { ...state, isLoading: false, error: action.error };
    case types.SUBSCRIPTION_STATIC_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.SUBSCRIPTION_STATIC_SUCCESS:
      return { ...state, isLoading: false, error: null };
    case types.SUBSCRIPTION_STATIC_FAILURE:
      return { ...state, isLoading: false, error: action.error };
    case types.SUBSCRIPTION_CODE_REVIEW_RENEW_REQUEST:
    case types.SUBSCRIPTION_CODE_REVIEW_CANCEL_REQUEST:
    case types.SUBSCRIPTION_STATIC_CANCEL_REQUEST:
    case types.SUBSCRIPTION_CODE_REVIEW_REQUEST:
    case types.UPDATE_BILLING_INFO_REQUEST:
      return { ...state, isUpdating: true, error: null };
    case types.SUBSCRIPTION_CODE_REVIEW_RENEW_SUCCESS:
    case types.SUBSCRIPTION_CODE_REVIEW_CANCEL_SUCCESS:
    case types.SUBSCRIPTION_STATIC_CANCEL_SUCCESS:
    case types.SUBSCRIPTION_CODE_REVIEW_SUCCESS:
    case types.UPDATE_BILLING_INFO_SUCCESS:
      return { ...state, isUpdating: false };
    case types.SUBSCRIPTION_CODE_REVIEW_RENEW_FAILURE:
    case types.SUBSCRIPTION_CODE_REVIEW_CANCEL_FAILURE:
    case types.SUBSCRIPTION_STATIC_CANCEL_FAILURE:
    case types.SUBSCRIPTION_CODE_REVIEW_FAILURE:
    case types.UPDATE_BILLING_INFO_FAILURE:
      return { ...state, isUpdating: false, error: action.error };
    case types.TOGGLE_NOTES_LOCK_REQUEST:
      return { ...state, isUpdating: true, error: null };
    case types.TOGGLE_NOTES_LOCK_SUCCESS:
      return { ...state, isUpdating: false };
    case types.TOGGLE_NOTES_LOCK_FAILURE:
      return { ...state, isUpdating: false, error: action.error };
    case types.TOGGLE_FULL_REPO_SEARCH_REQUEST:
      return { ...state, isUpdating: true, error: null };
    case types.TOGGLE_FULL_REPO_SEARCH_SUCCESS:
      return { ...state, isUpdating: false };
    case types.TOGGLE_FULL_REPO_SEARCH_FAILURE:
      return { ...state, isUpdating: false, error: action.error };
    case types.INVOICE_REQUEST:
      return { ...state, isLoadingInvoices: true, error: null };
    case types.INVOICE_SUCCESS:
      return {
        ...state,
        isLoadingInvoices: false,
        invoices: action.invoices,
      };
    case types.INVOICE_FAILURE:
      return { ...state, isLoadingInvoices: false, error: action.error };
    case types.MARK_PROJECT_ONBOARDED_REQUEST:
      return { ...state, isUpdating: true, error: null, errorCode: null };
    case types.MARK_PROJECT_ONBOARDED_SUCCESS:
      return { ...state, isUpdating: false, error: null, errorCode: null };
    case types.MARK_PROJECT_ONBOARDED_FAILURE:
      return {
        ...state,
        isUpdating: false,
        error: action.error,
        errorCode: action.errorCode,
      };
    default:
      return state;
  }
};

export const actions = {
  fetchDetailedOrganization: (uuid) => ({
    type: types.ORGANIZATION_REQUEST,
    uuid,
  }),
  updateOrganizationBillingPlan: (plan, organizationUuid) => ({
    type: types.UPDATE_BILLING_PLAN_REQUEST,
    plan,
    organizationUuid,
  }),
  renewCodeReviewSubscription: (organizationUuid) => ({
    type: types.SUBSCRIPTION_CODE_REVIEW_RENEW_REQUEST,
    organizationUuid,
  }),
  renewStaticSubscription: (organizationUuid) => ({
    type: types.SUBSCRIPTION_STATIC_RENEW_REQUEST,
    organizationUuid,
  }),
  cancelCodeReviewSubscription: (organizationUuid) => ({
    type: types.SUBSCRIPTION_CODE_REVIEW_CANCEL_REQUEST,
    organizationUuid,
  }),
  cancelStaticSubscription: (organizationUuid) => ({
    type: types.SUBSCRIPTION_STATIC_CANCEL_REQUEST,
    organizationUuid,
  }),
  initializeCodeReviewSubscription: (organizationUuid) => ({
    type: types.SUBSCRIPTION_CODE_REVIEW_REQUEST,
    organizationUuid,
  }),
  initializeStaticSubscription: (organizationUUID) => ({
    type: types.SUBSCRIPTION_STATIC_REQUEST,
    organizationUUID,
  }),
  toggleNotesLock: (organizationUUID, enabled) => ({
    type: types.TOGGLE_NOTES_LOCK_REQUEST,
    organizationUUID,
    enabled,
  }),
  toggleFullRepoSearch: (organizationUUID, enabled) => ({
    type: types.TOGGLE_FULL_REPO_SEARCH_REQUEST,
    organizationUUID,
    enabled,
  }),
  fetchOrganizationInvoiceHistory: (uuid) => ({
    type: types.INVOICE_REQUEST,
    uuid,
  }),
  updateOrganizationProduct: (organizationUUID, productName, enabled) => ({
    type: types.ORGANIZATION_PRODUCT_REQUEST,
    organizationUUID,
    productName,
    enabled,
  }),
  markProjectsOnboarded: (organizationUUID) => ({
    type: types.MARK_PROJECTS_ONBOARDED_REQUEST,
    organizationUUID,
  }),
  markOrganizationOnboarded: (organizationUUID) => ({
    organizationUUID,
  }),
  updateOrganizationBillingInfo: (organizationUUID, token) => ({
    type: types.UPDATE_BILLING_INFO_REQUEST,
    organizationUUID,
    token,
  }),
};

export const selectors = {
  isLoadingInvoices: (state) => state.organizations.isLoadingInvoices,
  error: (state) => state.organizations.error,
  organizationByUUID: (state, uuid) => {
    return state.organizations.byUUID[uuid];
  },
  invoices: (state) => {
    return state.organizations.invoices;
  },
  isLoading: (state) => {
    return state.isLoading;
  },
  hasBillingInfo: (state, uuid) => {
    const org = state.organizations.byUUID[uuid];
    return Boolean(org && org.billing && org.billing.card_last_four);
  },
  hasNotesLocked: (state, uuid) => {
    const detailedOrganization = organizationDetailSelector(state);
    const isOwner = ownsOrganization(state, uuid);
    return Boolean(
      !isOwner && detailedOrganization?.notes_from_organization_locked
    );
  },
};
